<template>
  <v-card id="frm-login" class="form-card" elevation="0">
    <v-card-title>
      <v-img
        v-if="showLogo"
        lazy-src="@/img/easyplanner-logo.png"
        src="@/img/easyplanner-logo.png"
        height="110px"
        contain
        alt="EASYPLANNER"
      ></v-img>
    </v-card-title>
    <v-card-text>
      <!-- QUESTO DEVE ESSERE UN COMPONENTE -->
      <!-- <div class="loginCard"> -->

      <v-col cols="12" class="text-center" style="margin-bottom: 2vh">
        <h1 class="company-name" v-if="companyInfo != null">
          {{ companyInfo.ragioneSociale }}
        </h1>
        <!-- <p style="font-size: 30px" v-if="companyInfo != null" class="subtitle-1">
        {{ companyInfo.indirizzo }}
      </p> -->
      </v-col>
      <v-col cols="12" style="margin-bottom: 0.5vh">
        <v-text-field
          ref="input"
          label="Username"
          name="username"
          v-model="username"
        v-on:keyup.enter="subitOwnerLogin"
          required
          :rules="[() => !!username || 'This field is required']"
          type="text"
          filled
        ></v-text-field>
      </v-col>

      <v-col cols="12" style="margin-bottom: 1vh">
        <v-text-field
          ref="input"
          label="Password"
        v-on:keyup.enter="subitOwnerLogin"
          v-model="password"
          name="password"
          filled
          required
          :rules="[() => !!password || 'This field is required']"
          :type="passwordFieldType"
          :append-icon="passwordIcon"
          @click:append="showPassword()"
        ></v-text-field>

        <v-btn text @click="forgotPassword()" color="primary">
          Forgot Password?
        </v-btn>
      </v-col>

      <v-col cols="6" offset-lg="6">
        <v-btn large class="btnLogin" @click="submitLogin" block>
          LOG IN
          <template v-slot:loader>
            <span>Logging in...</span>
          </template>
        </v-btn>
      </v-col>
      <v-snackbar v-model="ShowSnackbar" :timeout="5000">
        {{ error }}

        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="error = ''">
            Close
          </v-btn>
        </template>
      </v-snackbar>

      <v-dialog v-model="dialog" width="1000">
        <v-card>
          <FrmRecoverPassword
            v-on:close-dialog="closeDialog"
          ></FrmRecoverPassword>
        </v-card>
      </v-dialog>
      <!-- </div> -->
    </v-card-text>
  </v-card>
</template>


<style lang="scss">
.loginCard {
  padding: 60px !important;
}
h1.company-name {
  color: #cf1818;
}
.btnLogin {
  background-color: #5a99b8 !important;
  color: #ffffff !important;
}
</style>


<script>
import EasyPlanClient from "../../utils/EasyPlanClient.js";
import FrmRecoverPassword from "../../components/FrmRecoverPassword/FrmRecoverPassword.vue";
import SessionHelper from "../../utils/SessionHelper";
import Signup from "../../views/Signup";
export default {
  components: { Signup, FrmRecoverPassword },
  props: {
    showLogo: { type: Boolean, default: true },
  },
  data() {
    return {
      companyInfo: null,
      loader: null,
      dialog: false,
      username: "",
      password: "",
      error: "",
      passwordIcon: "mdi-lock",
      passwordFieldType: "password",
    };
  },
  methods: {
    closeDialog: function () {
      this.dialog = false;
    },
    submitLogin() {
      this.loader = "loading";
      EasyPlanClient.User.Login(
        this.username,
        this.password,
        this.$route.params.companyAlias
      )
        .then((res) => {
          console.debug("risposta user activation:");
          console.debug(res);
          EasyPlanClient.SetJWT(res.data.data);
          localStorage.userToken = res.data.data;
          SessionHelper.loadUserInfo(this.$route.params.companyAlias, () => {
            this.$router.push({
              name: "dashboard",
              params: { companyAlias: this.$route.params.companyAlias },
            });
          });

          console.log(res, "res");
        })
        .catch((error) => {
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    showPassword() {
      this.passwordIcon =
        this.passwordIcon === "mdi-lock" ? "mdi-lock-open-variant" : "mdi-lock";
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },

    forgotPassword() {
      this.dialog = true;
    },
  },

  computed: {
    ShowSnackbar: {
      get() {
        return this.error.length > 0;
      },
      set(value) {
        if (!value) this.error = "";
      },
    },
  },
  created: function () {
    console.debug(localStorage.userToken);
    if (
      localStorage.userToken != undefined &&
      localStorage.userToken != "null"
    ) {
      console.debug("redirecting");
      EasyPlanClient.SetJWT(localStorage.userToken);
      this.$router.push({
        name: "dashboard",
        params: { companyAlias: this.$route.params.companyAlias },
      });
      console.debug(this.$route.params.companyAlias);
    } else {
      SessionHelper.loadCompanyInfo(this.$route.params.companyAlias, (info) => {
        this.companyInfo = info;
      });
      // this.loadCompanyInfo();
    }
  },
};
</script>